
const postalCodeValidatorAU = (postcode) => {
    const zipFormat = new RegExp('^[0-9]{4}$');
    return postcode && zipFormat.test(postcode);
};

export default postalCodeValidatorAU;
